import { defineStore } from 'pinia';

export const useModalOverlayStore = defineStore('modalOverlay', {
  state: () => ({
    showModal: {},
    modal: {
      id: '',
      title: '',
      width: '',
      component: null,
      props: {},
    },
  }),
  actions: {
    toggle(id) {
      this.showModal[id] = !this.showModal[id];
    },
    close(id) {
      this.showModal[id] = false;
    },
    setModalOverlay(modal) {
      this.modal = modal;
    },
    setModalOverlayVisibility(id) {
      this.toggle(id);
    },
  },
});
